import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export default function NoAccessView() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center gap-4 py-12">
      <h2 className="text-xl font-semibold text-foreground">Can&apos;t access page!</h2>
      <Button onClick={() => navigate('/in/account/profile')}>Go to settings</Button>
    </div>
  );
}
